import './responsive/darkMode.st.css';
import './responsive/CounterBadge.st.css';
import './responsive/CircularProgressBar.st.css';
import { st, classes } from './responsive.st.css';
export default (function (_ref) {
  var darkMode = _ref.darkMode;
  return st(classes.root, {
    darkMode: darkMode
  });
});